import { render, staticRenderFns } from "./CovidView.vue?vue&type=template&id=e13db0a6"
import script from "./CovidView.vue?vue&type=script&lang=js"
export * from "./CovidView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports